import type { App } from 'vue';
import MLink from './MLink/MLink.vue';
import MRouterLink from './MLink/MRouterLink.vue';
import MPage from './Page/MPage.vue';
import MPageContent from './Page/MPageContent.vue';
import MHeading from './MHeading/MHeading.vue';
import MDateTime from './MDateTime/MDateTime.vue';
import MButton from './MButton/MButton.vue';
import MIcon from './MIcon/MIcon.vue';
import MAlert from './MAlert/MAlert.vue';
import MForm from './MForm/MForm.vue';
import MFormControl from './MFormControl/MFormControl.vue';
import MDropDown from './MDropDown/MDropDown.vue';
import MMoney from './MMoney/MMoney.vue';
import MContainer from './MContainer/MContainer.vue';
import MTitleBar from './MTitleBar/MTitleBar.vue';
import MActionList from './MActionList/MActionList.vue';

const registerComponents = (app: App) => {
  app.component('MActionList', MActionList);
  app.component('MHeading', MHeading);
  app.component('MPage', MPage);
  app.component('MIcon', MIcon);
  app.component('MMoney', MMoney);
  app.component('MDateTime', MDateTime);
  app.component('MButton', MButton);
  app.component('MAlert', MAlert);
  app.component('MForm', MForm);
  app.component('MFormControl', MFormControl);
  app.component('MDropDown', MDropDown);
  app.component('MPageContent', MPageContent);
  app.component('MRouterLink', MRouterLink);
  app.component('MLink', MLink);
  app.component('MContainer', MContainer);
  app.component('MTitleBar', MTitleBar);
};

export {
  MPage,
  MPageContent,
  MHeading,
  MDateTime,
  MButton,
  MContainer,
  MIcon,
  MAlert,
  MMoney,
  MForm,
  MFormControl,
  MDropDown,
  MRouterLink,
  MTitleBar,
  registerComponents,
};
